import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/CMSComponents/Components/CurrentLocationComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/animation/ScrollVisibilityComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/GlobalStore/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/NavBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/utils/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/utils/SmartBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.1.0_next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0__react@19.1.0_typescript@5.8.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.1.0_next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0__react@19.1.0_typescript@5.8.3/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"components/BaseLayout/index.tsx\",\"import\":\"IBM_Plex_Sans_Arabic\",\"arguments\":[{\"weight\":[\"100\",\"300\",\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"iBMPlexSansArabic\"}");
